import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=6245b28d&scoped=true&"
import script from "./pageHeader.vue.js?vue&type=script&lang=js&"
export * from "./pageHeader.vue.js?vue&type=script&lang=js&"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=6245b28d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6245b28d",
  null
  
)

export default component.exports